import { Component, type ErrorInfo, type PropsWithChildren } from 'react';

interface State {
  hasError: boolean;
}

// Class component is intentional — error boundaries have no hooks
// equivalent in React 19. Sits once at the provider root; feature-level
// boundaries (e.g. around the document viewer) wrap this same class.
export class ErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Unhandled UI error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" className="error-boundary">
          <h2>Something went wrong</h2>
          <p>Try reloading the page. If the problem continues, contact support.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
